module.exports = __webpack_public_path__ + "static/media/a.eaf6e247.m4a";